import React from "react";
import styled from "styled-components";
import { mixinSkins } from "../../../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { lionSkin } from "../skins/project-l";
import { CTA } from "../../../../../components/CTA";
import { BetaMasthead } from "../../../components/BetaMasthead";
import { z } from "zod";
import { BetaRegistrationMastheadBladeSchema, } from "../../../schemas/BetaRegistrationMasthead";
import { useBetaHubRouter } from "../../../functional/hooks/useBetaHubRouter";
import { BetaLoader } from "../../../components/BetaLoader";
export const BetaCenteredMastheadContractSchema = BetaRegistrationMastheadBladeSchema.extend({
    type: z.literal("betaCenteredMasthead"),
});
const _BetaCenteredMasthead = ({ header, className, backdrop, buttons = [], campaignID, ...bladeProps }) => {
    const { isLoading, isAllowedRoute } = useBetaHubRouter({ campaignID });
    const primaryButton = buttons[0];
    return (React.createElement(BetaLoader, { isLoading: isLoading, isAllowedRoute: isAllowedRoute, palette: "palette3" },
        React.createElement(BetaMasthead, { className: className, header: header, backdrop: backdrop, isFullHeight: true, ...bladeProps },
            React.createElement(CTA, { className: "primary-cta", ...primaryButton }))));
};
export const BetaCenteredMasthead = styled(_BetaCenteredMasthead) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.RiotProductLion]: lionSkin,
})}
`;
//# sourceMappingURL=BetaCenteredMasthead.js.map